import React, {useState} from "react";
import "./index.scss";
import classNames from "classnames";
import {FieldAttributes, useField, useFormikContext} from "formik";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@material-ui/core";
import KeyboardArrowDownOutlined from '@material-ui/icons/KeyboardArrowDownOutlined'
import {IFormattedResponse} from "../../../model/parametrizedResponse";
export interface SelectOption {
    label: string;
    value: any;
}

interface Props {
    options?: SelectOption[];
    placeholder: string;
    asString?: (obj: any) => string;
    fromString?: (key: any, options: SelectOption[]) => any;
    disabled: boolean;
    hidden: boolean;
    errorMessage?: string;
    backEndName: string;
    setFieldToUpdate: (fieldToUpdate: any) => void;
    formatResponse: (obj: any) => IFormattedResponse;
    onChangeListener?: (val: any) => void;
    value?: any;
}

export const SelectOneInputOld = (props: FieldAttributes<Props>) => {
    const {name, hidden, disabled, errorMessage, backEndName, setFieldToUpdate, formatResponse, onChangeListener, value} = props;
    const {options, placeholder, asString, fromString} = props;
    const [open, setOpen] = useState<boolean>(false);

    // eslint-disable-next-line

    const [field, _, helpers] = useField({name});

    const {handleBlur} = useFormikContext();

    let className: string = classNames({
        "select-one-input": true,
    });
    if (props.className) {
        className = `${className} ${props.className}`
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        if(onChangeListener){
            onChangeListener(event.target.value);
        }
        const value = fromString ? fromString(event.target.value, options) : event.target.value;
        let formattedValue = value == null ? {quotationValue: null, value: null}  : formatResponse(value);
        helpers.setValue(formattedValue.quotationValue);
        setFieldToUpdate({name: backEndName, value: formattedValue.value});
    };

    let fieldValue = asString?.(field.value == null ? value : field.value) ?? (field.value == null ? value : field.value);
    if (fieldValue == null) fieldValue = '';

    const getTitle = () => {
        let selectOption = options.find(option => {
            const value = asString?.(option.value) ?? option.value;
            return value === fieldValue;
        });

        return selectOption?.label;
    };

    return (
        <div className={className} hidden={hidden}>
            <FormControl className={`select-one-input__select ${open ? 'arrow-style-open' : 'arrow-style-close'}`} error={errorMessage !== null && errorMessage !==  ''} variant="outlined"
                         fullWidth={true}>
                <InputLabel id="demo-simple-select-outlined-label">{placeholder}</InputLabel>
                <Select
                    labelId={name}
                    id={name}
                    value={fieldValue}
                    title={getTitle()}
                    disabled={disabled}
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    IconComponent={KeyboardArrowDownOutlined}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transitionDuration: 0,
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={placeholder}>
                    {options.map((option, index) => {
                        const value = asString ? asString(option.value) : option.value;


                        return <MenuItem key={index} value={value}
                                         className='select-one-input__item'>{option.label}</MenuItem>;
                    })}
                </Select>

                {errorMessage !== '' && <FormHelperText>{errorMessage}</FormHelperText>}
            </FormControl>
        </div>
    )
};
